module.exports = __webpack_public_path__ + "static/media/elsa-lose.10efde4e.png";